import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";
import IndustriesIndex from "@/pages/IndustriesIndex";
import IndustryDetail from "@/pages/IndustryDetail";
import About from "@/pages/About";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightDetail from "@/pages/InsightDetail";
import CaseStudiesIndex from "@/pages/CaseStudiesIndex";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Careers from "@/pages/Careers";
import JobDetail from "@/pages/JobDetail";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import Search from "@/pages/Search";
import NotFound from "@/pages/NotFound";
import Legal from "@/pages/Legal";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/industries" element={<IndustriesIndex />} />
            <Route path="/industries/:slug" element={<IndustryDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/insights" element={<InsightsIndex />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/case-studies" element={<CaseStudiesIndex />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:slug" element={<JobDetail />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/search" element={<Search />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/cookies" element={<Legal kind="cookies" />} />
            <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
